"use strict";

(function () {
  'use strict';

  angular.module('lr.Properties').directive('lrProperty', ['$window', '$timeout', 'PropertiesFactory', 'StateFactory', 'DeviceActions', 'PropertyStateValue', 'GuestState', 'PropertyStateType', 'DataStreamFactory', '$filter', 'StateID', 'Utils', 'transactionConstants', '$uibModal', 'eventTypes', function ($window, $timeout, PropertiesFactory, StateFactory, DeviceActions, PropertyStateValue, GuestState, PropertyStateType, DataStreamFactory, $filter, StateID, Utils, transactionConstants, $uibModal, eventTypes) {
    return {
      restrict: 'AE',
      scope: {
        property: '=',
        settings: '=',
        detailsId: '='
      },
      templateUrl: 'app/properties/lr-property-directive.html',
      link: function link(scope, ele) {
        var Properties = PropertiesFactory;
        var State = StateFactory.State;
        var EventStream = DataStreamFactory.generator();
        scope.pageDataID = {};
        scope.showDetails = false;
        scope.details = {};
        scope.notes = [];
        scope.tabNum = 1;
        scope.img = '';
        scope.state = {};
        scope.propertyStateType = PropertyStateType;
        scope.propertyStateValue = PropertyStateValue;
        scope.guestState = GuestState;
        scope.show = false;
        scope.realTime = EventStream;
        scope.StateID = StateID;
        scope.eventTypes = eventTypes;
        var text = {
          ready: 'Ready',
          inProgress: 'In-Progress',
          inActive: 'Not Ready',
          defaultText: 'na'
        };
        var cssClasses = {
          ready: 'lr-ready',
          inProgress: 'lr-progress',
          inactive: 'lr-inactive',
          defaultState: 'lr-default'
        };

        scope.viewPropertyWorkOrderByType = function (pageDataID, type, status) {
          var url = '/work-orders/property/' + pageDataID;

          if (type) {
            url += '?type=' + type;
          }

          if (status) {
            url += '?status=' + status;
          }

          $window.open(url, '_blank');
        };

        scope.flagChange = function () {
          _getDetails();
        };

        function _getDetails() {
          var pageDataID = scope.property.pageDataID;
          var transactions = scope.property.transactions;
          Properties.getDetails(pageDataID, Utils.DateKeeper.getDate()).then(function (data) {
            // console.log('getDetails data', data);
            scope.property.state = data.data.state;
            EventStream.getEvents(null, 0, scope.property.pageDataID).then(function (data) {
              scope.events = angular.copy(data.data);
            }, function (error) {
              console.log(error);
              scope.events = [];
            });

            if (scope.property.images[0]) {
              scope.img = Properties.buildImageLink(data.data.images[0], 1, 550);
            } else {
              scope.img = false;
            }
          }, function (data) {
            //todo: show errors
            console.log(data);
          });

          if (transactions && transactions.length) {
            var transaction = transactions[0];
            Properties.getNotes(transaction.TransactionID).then(function (data) {
              scope.property.notes = data.data;
            })["catch"](function (err) {
              console.log(err);
            });
          }
        }

        if (scope.property.images[0]) {
          scope.url = Properties.buildImageLink(scope.property.images[0], 1, 250);
        } else {
          scope.url = false;
        }

        scope.getTransactionNoteType = function (noteType) {
          var transNoteTypes = transactionConstants.transactionNoteType;

          for (var prop in transNoteTypes) {
            if (transNoteTypes.hasOwnProperty(prop)) {
              if (transNoteTypes[prop] === noteType) return prop;
            }
          }
        };

        scope.getPropertyState = function (state) {
          if (state === 0) {
            return 'Unknown';
          }

          if (state === 1) {
            return 'Unoccupied Not Ready';
          }

          if (state === 2) {
            return 'Unoccupied Ready';
          }

          if (state === 3) {
            return 'Occupied';
          }
        };

        scope.getState = function (state) {
          if (state === PropertyStateValue.unknown) {
            return 'Unknown';
          }

          if (state === PropertyStateValue.notNeeded) {
            return 'Not Needed';
          }

          if (state === PropertyStateValue.pending) {
            return 'Pending';
          }

          if (state === PropertyStateValue.readyFor) {
            return 'Ready For';
          }

          if (state === PropertyStateValue.inProgress) {
            return 'In Progress';
          }

          if (state === PropertyStateValue.complete) {
            return 'Complete';
          }

          if (state === PropertyStateValue.flagged) {
            return 'Flagged';
          }

          if (state === PropertyStateValue.onHold) {
            return 'On Hold';
          }
        };

        scope.getStateStatus = function (stateID) {
          if (stateID === PropertyStateValue.notNeeded) {
            return cssClasses.defaultState;
          }

          if (stateID === PropertyStateValue.complete) {
            return cssClasses.ready;
          }

          if (stateID === PropertyStateValue.inProgress) {
            return cssClasses.inProgress;
          }

          if (stateID === PropertyStateValue.pending) {
            return cssClasses.inactive;
          }

          if (stateID === PropertyStateValue.readyFor) {
            return cssClasses.defaultState;
          }

          return cssClasses.defaultState;
        };

        scope.close = function () {
          scope.show = false;
          scope.tabNum = 0;
          ele.removeClass('lr-property-list--active');
        };

        scope.changeGuestState = function (transactionId, pageDataId, guestState) {
          scope.guestStateLoading = true;
          State.changeGuestState(transactionId, pageDataId, guestState).then(function (data) {
            // console.log('data', data);
            _getDetails();
          })["catch"](function (error) {// console.log('error', error);
          });
        };

        scope.changeState = function (strType, stateType, newState, stateID) {
          var newStrState = stateType !== PropertyStateType.guest ? scope.getState(newState) : scope.getPropertyState(newState);
          var modalInstance = $uibModal.open({
            templateUrl: 'app/properties/status-change/status-change.modal.html',
            controller: 'StatusChangeModalCtrl',
            resolve: {
              modalData: function modalData() {
                return {
                  property: scope.property,
                  type: strType,
                  newStrState: newStrState,
                  newState: newState,
                  stateID: stateID
                };
              }
            }
          });
          modalInstance.result.then(function (result) {
            if (result) {
              scope.property.state[stateID] = newState;
              var sendData = {
                stateType: stateType,
                newState: newState,
                PageDataID: scope.property.pageDataID,
                reason: result.reason
              };
              Properties.stateOverride(sendData).then(function (data) {
                _getDetails();
              });
            }
          }, function () {});
        }; //todo: move this to a service


        scope.getGuestStateIDStatus = function (stateID) {
          if (stateID === GuestState.unoccupiedReady) {
            return cssClasses.defaultState;
          }

          if (stateID === GuestState.occupied) {
            return cssClasses.ready;
          }

          if (stateID === GuestState.unoccupiedNotReady) {
            return cssClasses.inactive;
          }

          return cssClasses.defaultState;
        };

        scope.expand = function (tab) {
          if (scope.show) {
            return;
          }

          scope.show = !scope.show;
          ele.removeClass('lr-property-list--active');
          ele.addClass('lr-property-list--active');

          _getDetails();

          if (tab) {
            scope.tab(tab);
          }
        };

        scope.tab = function (tabNumber) {
          scope.tabNum = tabNumber;
        };
      }
    };
  }]).directive('lrOccupancy', ['$window', '$timeout', '$compile', 'Utils', function ($window, $timeout, $compile, Utils) {
    var occupancyIn = '<div class="lr-triangle bottom-right lr-triangle--booked" style="left: -30px;"></div>' + '<div class="lr-rectangle {{reservationType}}">' + '  <div class="truncate lr-triangle--text"  ng-attr-title="{{guest}}"> {{guest}}</div>' + '</div>';
    var occupancyEarlyIn = '<div class="lr-triangle bottom-right lr-triangle--booked-early-in" style="left: -30px;"></div>' + '<div class="lr-rectangle {{reservationType}}">' + '  <div class="truncate lr-triangle--text"  ng-attr-title="{{guest}}"> {{guest}}</div>' + '</div>';
    var occupancyOut = '<div class="lr-rectangle {{reservationType}}">' + '  <div class="truncate lr-triangle--text"  ng-attr-title="{{guest}}"> {{guest}}</div>' + '</div>' + '<div class="lr-triangle top-left lr-triangle--booked" style="  right: -30px;top: 0;">';
    var occupancyLateOut = '<div class="lr-rectangle {{reservationType}}">' + '  <div class="truncate lr-triangle--text"  ng-attr-title="{{guest}}"> {{guest}}</div>' + '</div>' + '<div class="lr-triangle top-left lr-triangle--booked-late-out" style="  right: -30px;top: 0;">';
    var occupancyOutIn = '<div class="lr-turnover">' + '<div class="lr-turnover__in">' + '<div class="lr-rectangle {{reservationOne}}">' + '<div class="truncate lr-triangle--text" ng-attr-title="{{guest}}"> {{guest}}</div>' + '</div>' + '<div class="lr-triangle top-left lr-triangle--booked" style="  right: 80px;top: 0;"></div>' + ' </div>' + '<div class="lr-turnover__out">' + '<div class="lr-triangle bottom-right lr-triangle--booked" style="left: 80px;"></div>' + ' <div class="lr-rectangle {{reservationTwo}}">' + '<div class="truncate lr-triangle--text"ng-attr-title="{{guestTwo}}"> {{guestTwo}}</div>' + ' </div>' + ' </div>' + '  </div>';
    var occupied = '<div class="lr-rectangle {{reservationType}}">' + '<div class="truncate lr-triangle--text" ng-attr-title="{{guest}}"> {{guest}}</div>' + '</div>';

    function fixTime(time, hour) {
      var returnValue;
      var timeSplit = time.split('T');
      timeSplit[1] = 'T' + hour;
      returnValue = timeSplit.join('');
      return returnValue;
    }

    function getTransactionType(type) {
      if (type === 1) {
        return 'lr-rectangle--owner';
      }

      if (type === 3) {
        return 'lr-rectangle--admin';
      }

      return 'lr-rectangle--booked';
    }

    var getTemplate = function getTemplate(transactions) {
      if (transactions.length > 1) {
        this.guest = transactions[1].GuestFullName;
        this.guestTwo = transactions[0].GuestFullName;
        this.reservationOne = getTransactionType(transactions[1].ReservationTypeID);
        this.reservationTwo = getTransactionType(transactions[0].ReservationTypeID);
        return occupancyOutIn;
      }

      var transaction = transactions[0];
      var today = new Date(Utils.DateKeeper.getDate()).setHours(0, 0, 0, 0);
      var checkIn = new Date(fixTime(transaction.StartDate, '12:00:00')).setHours(0, 0, 0, 0);
      var checkOut = new Date(fixTime(transaction.EndDate, '12:00:00')).setHours(0, 0, 0, 0);
      this.guest = transaction.GuestFullName;
      this.reservationType = getTransactionType(transaction.ReservationTypeID);

      if (checkIn === today) {
        if (parseInt(transaction.EarlyCheckIn) === 1) {
          return occupancyEarlyIn;
        } else {
          return occupancyIn;
        }
      }

      if (checkOut === today) {
        if (parseInt(transaction.LateCheckOut) === 1) {
          return occupancyLateOut;
        } else {
          return occupancyOut;
        }
      }

      if (today > checkIn && today < checkOut) {
        return occupied;
      }
    };

    return {
      restrict: 'AE',
      scope: {
        data: '='
      },
      link: function link(scope, ele) {
        scope.$watch('data', function (newValue) {
          scope.transactions = newValue;

          if (scope.transactions) {
            ele.html(getTemplate.call(scope, scope.transactions)).show();
            $compile(ele.contents())(scope);
          }
        });
      }
    };
  }]).directive('lrPropertyStatus', ['$compile', 'PropertyStateValue', 'GuestState', function ($compile, PropertyStateValue, GuestState) {
    return {
      restrict: 'AE',
      scope: {
        state: '='
      },
      link: function link(scope, ele) {
        scope.work = {};
        var cssClasses = {
          ready: 'lr-ready',
          inProgress: 'lr-progress',
          inactive: 'lr-inactive',
          defaultState: 'lr-default'
        }; //todo: move this to a service

        scope.getStateStatus = function (stateID) {
          if (stateID === PropertyStateValue.complete) {
            return cssClasses.ready;
          }

          if (stateID === PropertyStateValue.inProgress) {
            return cssClasses.inProgress;
          }

          if (stateID === PropertyStateValue.pending || stateID === PropertyStateValue.readyFor) {
            return cssClasses.inactive;
          }

          return cssClasses.defaultState;
        }; //todo: move this to a service
        //todo: show - hide depending on property status


        var template = '' + '<div style="display: inline;">' + '<div class="btn-group">' + '<div class="fa-stack fa-lg ng-scope" title="Clean">' + '<i class="fa fa-square fa-stack-2x"' + ' ng-class="getStateStatus(state.CleaningStateID)" ></i>' + '<span class=" fa-stack-1x fa-inverse ">C</span>' + '</div>' + '<div class="fa-stack fa-lg ng-scope" title="Inspection">' + '<i class="fa fa-square fa-stack-2x"' + ' ng-class="getStateStatus(state.InspectionStateID)" ></i>' + '<span class=" fa-stack-1x fa-inverse ">I</span>' + '</div>' + '<div class="fa-stack fa-lg ng-scope" title="Maintenance">' + '<i class="fa fa-square fa-stack-2x"' + ' ng-class="getStateStatus(state.MaintenanceStateID)" ></i>' + '<span class=" fa-stack-1x fa-inverse ">M</span>' + '</div>' + '</div>' + '</div>';
        ele.html(template).show();
        $compile(ele.contents())(scope);
      }
    };
  }]).directive('lrDeviceAction', ['$window', '$timeout', '$compile', 'DeviceActions', function ($window, $timeout, $compile, DeviceActions) {
    return {
      restrict: 'AE',
      scope: {
        command: '=',
        device: '='
      },
      link: function link(scope, ele) {
        var template = '<button type="button" class="btn" ng-click="action()">{{command.name}}</button>';

        scope.action = function () {
          var data = DeviceActions.createPacket(scope.command.bodyType, scope.command.bodyVariables, scope.device);
          DeviceActions.execute(scope.command.method, scope.command.url, data, true);
        };

        ele.html(template).show();
        $compile(ele.contents())(scope);
      }
    };
  }]).controller('StatusChangeModalCtrl', ['$uibModalInstance', '$scope', 'User', 'modalData', '$lrNotifier', function ($uibModalInstance, $scope, User, modalData, $lrNotifier) {
    $scope.err = '';
    $scope.data = {
      reason: ''
    };
    $scope.property = modalData.property;
    $scope.type = modalData.type;
    $scope.newStrState = modalData.newStrState;
    var token = User.getToken();

    $scope.submit = function () {
      $scope.err = '';

      if (!$scope.data.reason) {
        $scope.err = 'Please Provide a Reason for the Status Change';
        return;
      }

      $uibModalInstance.close($scope.data);
      $lrNotifier.content('Loading...').show();
    };

    $scope.cancel = function () {
      $uibModalInstance.close();
    };

    $scope.open = function ($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened = true;
    };
  }]);
})();